(function () {
  'use strict';
  var root = document.querySelector('.alisio');
  if (!root) return;
  if (!CSS.supports('animation-timeline: view()')) {
    root.classList.add('a-io');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('.alisio .a-rv').forEach(function (el) { io.observe(el); });
  }
  var toast = document.createElement('div');
  toast.className = 'a-toast'; toast.setAttribute('role', 'status'); document.body.appendChild(toast);
  var tTimer;
  function say(msg) { toast.textContent = msg; toast.classList.add('is-on'); clearTimeout(tTimer); tTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2600); }
  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function (data) {
      document.dispatchEvent(new CustomEvent('alisio:cart:added', { detail: data }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:open'));
      return data;
    });
  }
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest('.alisio')) return;
    var size = ev.target.closest('.a-qa__size');
    if (size && !size.disabled) {
      var qa = size.closest('.a-qa');
      qa.querySelectorAll('.a-qa__size').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      size.setAttribute('aria-pressed', 'true');
      qa.dataset.variant = size.dataset.variant;
      var btn = qa.querySelector('.a-qa__btn'); if (btn) btn.disabled = false;
      return;
    }
    var add = ev.target.closest('.a-qa__btn');
    if (add) {
      ev.preventDefault();
      var q = add.closest('.a-qa');
      var vid = q.dataset.variant || add.dataset.variant;
      if (!vid) { say('Elige una talla'); return; }
      add.disabled = true;
      addToCart([{ id: Number(vid), quantity: 1 }])
        .then(function () { say('Añadido al carrito'); })
        .catch(function () { say('No se pudo añadir. Abre la ficha del producto.'); })
        .finally(function () { add.disabled = false; });
    }
  });
  document.querySelectorAll('.alisio [data-look]').forEach(function (look) {
    var dlg = look.querySelector('dialog.a-panel');
    if (!dlg) return;
    look.querySelectorAll('[data-open-look]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        var target = b.dataset.openLook;
        if (target) { var row = dlg.querySelector('[data-row="' + target + '"]'); if (row) row.scrollIntoView({ block: 'center' }); }
      });
    });
    dlg.querySelector('.a-panel__close').addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var all = dlg.querySelector('[data-add-look]');
    if (all) all.addEventListener('click', function () {
      var ids = Array.prototype.map.call(dlg.querySelectorAll('[data-row][data-variant]'), function (r) { return Number(r.dataset.variant); }).filter(Boolean);
      if (!ids.length) { say('Elige tallas desde cada producto'); return; }
      all.disabled = true;
      addToCart(ids.map(function (id) { return { id: id, quantity: 1 }; }))
        .then(function () { say('Look añadido al carrito'); dlg.close(); })
        .catch(function () { say('Algún producto no está disponible'); })
        .finally(function () { all.disabled = false; });
    });
  });
})();
